export default __webpack_public_path__ + "static/media/checked.f5aab68c.svg";